module.exports = __webpack_public_path__ + "static/img/certificateJYZ.15494762.jpg";